export default __webpack_public_path__ + "static/logo_icon-55004aa53bb12a77801223c7f01cb478.png";